import React from "react";
import { useAnimation as UseAnimation, motion } from "framer-motion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

function privacypolicy() {
  const img: any = "/static/images/term_bg.png";

  const imgAnimation = UseAnimation();

  const handleMouseMove = (e: any) => {
    const { clientX, clientY } = e;
    const moveX = clientX - window.innerWidth / 2;
    const moveY = clientY - window.innerHeight / 2;
    const offsetFactor = 15;
    imgAnimation.start({
      x: moveX / offsetFactor,
      y: moveY / offsetFactor,
    });
  };

  return (
    <div className="wrapper">
      <Header />

      <section className="key_visual">
        <motion.img
          // animate={imgAnimation}
          // onMouseMove={(e) => handleMouseMove(e)}
          src={img}
          alt="Terms and Conditions"
          loading="lazy"
        />
        <div className="img-bg" />
      </section>

      <section className="sv_content black-content">
        <div className="container">
          <div className="row">
            <div className="content-heading col-12">
              <h1 className="fw-bolder t-green mb-4">DISCLAIMER</h1>
            </div>
            <div className="col-12 c-content">
              <p className="t-white c-text mb-5">
                Welcome to ITP ASIA CO.,LTD. (referred to as ITP below) website.
                This website provides information about ITP ASIA CO.,LTD. and
                its services.
              </p>

              <p className="t-green c-text mb-2">
                By using ITP website, you agree to these conditions. Please read
                them carefully.
              </p>
              <p className="t-white c-text mb-5">
                When you visit our website to gain information or sending us an
                e-mail, you also will be subject to the guidelines, terms and
                agreements applicable to ITP website.
              </p>

              <p className="t-green c-text mb-2">PRIVACY</p>
              <p className="t-white c-text mb-5">
                Please review our Privacy Notice, which also governs your use of
                ITP website, to understand our practices.
              </p>

              <p className="t-green c-text mb-2">ELECTRONIC COMMUNICATION</p>
              <p className="t-white c-text mb-5">
                When you use ITP website, or send e-mail, and other
                communication from your desktop or mobile device to us, you are
                communicating with us electronically. You consent to receive
                communication from us electronically. We will communicate with
                you in a variety of ways, such as by e-mail, by posting notices
                and messages on this website. You agree that all agreement,
                notice, disclosure, and other communication that we provide to
                you electronically satisfy any legal requirement that such
                communication be in writing.
              </p>

              <p className="t-green c-text mb-2">COPYRIGHT</p>
              <p className="t-white c-text mb-5">
                All content included in or made available through ITP website,
                such as text, graphic, logo, button icon, image, audio clip,
                digital download, data compilation, and software is the property
                of ITP and protected by Thailand and international copyright
                laws. The compilation of all content included in or made
                available through ITP website is the exclusive property of ITP
                and protected by Thailand and international copyright laws.
              </p>

              <p className="t-green c-text mb-2">TRADEMARKS</p>
              <p className="t-white c-text mb-5">
                In addition, graphic, logo, page header, button icon, script,
                and service name included in or made available through ITP
                website are trademark or trade dress of ITP in Thailand and
                other countries.
              </p>

              <p className="t-green c-text mb-2">PATENTS</p>
              <p className="t-white c-text mb-5">
                One or more patents owned by ITP apply to the ITP website and to
                the features and services accessible via the ITP website.
                Portions of the ITP website operate under license of one or more
                patents.
              </p>

              <p className="t-green c-text mb-2">LICENSE AND ACCESS</p>
              <p className="t-white c-text mb-4">
                Subject to your compliance with these Conditions of Use, ITP or
                its content providers grant you a limited, non-exclusive,
                non-transferable, non-sub licensable license to access and make
                personal and non-commercial use of the ITP website. This license
                does not include any resale or commercial use of ITP website, or
                its contents; any collection and use of any product listings,
                descriptions, or prices; any derivative use of ITP website or
                its contents; any downloading, copying, or other use of account
                information for the benefit of any third party; or any use of
                data mining, robots, or similar data gathering and extraction
                tools. All rights not expressly granted to you in these
                Conditions of Use or any Service Terms are reserved and retained
                by ITP.
              </p>
              <p className="t-white c-text mb-5">
                No ITP website, nor any part of any ITP website, may be
                reproduced, duplicated, copied, sold, resold, visited, or
                otherwise exploited for any commercial purpose without express
                written consent of ITP. The licenses granted by ITP terminate if
                you do not comply with these Conditions of Use or any Service
                Terms.
              </p>

              <p className="t-green c-text mb-2">YOUR ACCOUNT</p>
              <p className="t-white c-text mb-5">
                When ITP website has sign in function, if you use ITP website,
                you are responsible for maintaining the confidentiality of your
                account and password and for restricting access to your
                computer, and you agree to accept responsibility for all
                activities that occur under your account or password. ITP
                reserves the right to refuse service, terminate accounts, remove
                or edit content, in its sole discretion.
              </p>

              <p className="t-green c-text mb-2">PRODUCT DESCRIPTION</p>
              <p className="t-white c-text mb-5">
                ITP attempts to be as accurate as possible. However, ITP does
                not warrant that product description or other content of any ITP
                Service is accurate, complete, reliable, current, or error-free.
              </p>

              <p className="t-green c-text mb-2">SITE POLICIES</p>
              <p className="t-white c-text mb-5">
                Please review our other policies, posted on this site. These
                policies also govern your use of ITP website. We reserve the
                right to make changes to our website, policies, Service Terms,
                and these Term and Condition at any time. If any of these
                conditions shall be deemed invalid, void, or for any reason
                unenforceable, that condition shall be deemed severable and
                shall not affect the validity and enforceability of any
                remaining condition.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default privacypolicy;
